import { useState } from "react";
import { createWidget, updateWidget, getWidget } from "./service";

function useWidget(workspaceId, assistantId) {
  const [widget, setWidget] = useState({
    data: {
      title: "",
      brandColor: "",
      fontColor: "",
      iconColor: "",
      inputfieldFontColor: "",
      firstMessage: "",
      question: "",
    },
    isLoading: true,
    isCreated: false,
  });

  const setIsLoading = (isLoading) =>
    setWidget((prevState) => {
      return {
        ...prevState,
        isLoading,
      };
    });

  async function fetchWidget(loading) {
    setIsLoading(loading);

    try {
      const response = await getWidget({ workspaceId, assistantId });
      if (response.status === 200) {
        const {
          title,
          brandColor,
          fontColor,
          iconColor,
          inputfieldFontColor,
          firstMessage,
          question,
        } = response.data.widget;
        setWidget({
          data: {
            title,
            brandColor,
            fontColor,
            iconColor,
            inputfieldFontColor,
            firstMessage,
            question,
          },
          isLoading: false,
          isCreated: true,
        });
      }
    } catch (e) {
      if (e.response.status === 400) {
        setWidget((prevState) => {
          return {
            ...prevState,
            isLoading: false,
          };
        });
      } else {
        setWidget((prevState) => {
          return {
            ...prevState,
            isLoading: false,
          };
        });
        console.error("Failed to get Widget");
      }
    }
  }

  async function createNewWidget() {
    try {
      const response = await createWidget({ workspaceId, assistantId });
      if (response.status === 200) {
        await fetchWidget(false);
      }
    } catch (e) {
      console.error("Failed to create widget");
    }
  }

  async function updateExistingWidget(payload) {
    try {
      const response = await updateWidget({
        workspaceId,
        assistantId,
        payload,
      });

      if (response.status === 200) {
        await fetchWidget(false);
      }
    } catch (e) {
      console.error("Failed to udpate widget");
    }
  }

  return {
    ...widget,
    fetchWidget,
    createNewWidget,
    updateExistingWidget,
  };
}

export default useWidget;
